import type { ResponsiveProperty } from "@daangn/carotene/css";
import { handleResponsiveProp } from "@daangn/carotene/css";
import clsx from "clsx";

import type { TextButtonSize, TextButtonVariant } from "./textButton.css";
import {
  textButtonBase,
  textButtonIconBase,
  textButtonIconSizeMedia,
  textButtonSizeMedia,
  textButtonVariant,
} from "./textButton.css";

export type TextButtonVariantProps = {
  size?: TextButtonSize | ResponsiveProperty<TextButtonSize>;
  variant?: TextButtonVariant;
};

export function textButton({
  size = "medium",
  variant = "neutral",
}: TextButtonVariantProps) {
  return {
    root: clsx(
      textButtonBase,
      textButtonVariant[variant],
      handleResponsiveProp(textButtonSizeMedia, size),
    ),
    icon: clsx(
      textButtonIconBase,
      handleResponsiveProp(textButtonIconSizeMedia, size),
    ),
  };
}
